module.exports = __webpack_public_path__ + "site/img/66.a787c664.jpg";